import { ZPermission } from "../ZBom3";

export const accessDenied = (
  action: ZPermission,
  permissions: ZPermission[],
): boolean => !permissions.includes(action);

export const accessGranted = (
  action: ZPermission,
  permissions: ZPermission[],
): boolean => !accessDenied(action, permissions);
